// extracted by mini-css-extract-plugin
module.exports = {"actionitem":"TripActivityScreen_actionitem__HJEEO"};